<template>
  <img :src="currentImage"
  @click="changeImage" />
</template/>
<script>

export default {
  name: 'Cities',
  data() {
    return {
      currentImage: "/assets/Valonia.png",
      images: [
        "../assets/Boulderglen.png",
        "../assets/Bronzeforge.png",
        "../assets/CelestialHeights.png",
        "../assets/CloverSprings.png",
        "../assets/Copperbrook.png",
        "../assets/CrescentPort.png",
        "../assets/Dragonsclutch.png",
        "../assets/EasternLocks.png",
        "../assets/Everfrost.png",
        "../assets/Falkhorn.png",
        "../assets/Firedeep.png",
        "../assets/Frostport.png",
        "../assets/Harbordock.png",
        "../assets/Helmstead.png",
        "../assets/Hillfar.png",
        "../assets/MapleFalls.png",
        "../assets/Moongarden.png",
        "../assets/Mossgrove.png",
        "../assets/Northpass.png",
        "../assets/Oakhaven.png",
        "../assets/Pinehaven.png",
        "../assets/Seaside.png",
        "../assets/Silverbridge.png",
        "../assets/SouthernChannels.png",
        "../assets/Stormkeep.png",
        "../assets/Thornbeak.png",
        "../assets/Valonia.png",
        "../assets/WesternGateway.png",
        "../assets/Windfell.png",
        "../assets/Winterspell.png",
      ]
    }
  },
  methods: {
    changeImage() {
      const currentIndex = this.images.indexOf(this.currentImage)

      let nextIndex = currentIndex + 1;
      if (nextIndex >= this.images.length) {
        nextIndex = 0
      }
      this.currentImage = this.images[nextIndex]
    }
  }
}
</script>
